import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MaleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"male"}/>
}
